import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import FastFilesLanding from './components/FastFilesLanding';
import FastFilesDashboard from './components/FastFilesDashboard';
import ShareFiles from './components/ShareFiles';
import ArchitectureViewResponsive from './components/ArchitectureViewResponsive';
import InteractiveArchitectureExplorer from './components/InteractiveArchitectureExplorer';
import Changelog from './components/Changelog';
import AdminTaskFlow from './components/AdminTaskFlow';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ShareFiles />} />
        <Route path="/create-receiver" element={<FastFilesLanding />} />
        <Route path="/dashboard" element={<Navigate to="/" replace />} />
        <Route path="/architecture-flow" element={<ArchitectureViewResponsive />} />
        <Route path="/explorer" element={<InteractiveArchitectureExplorer />} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/admin-tasks" element={<AdminTaskFlow />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="login" element={<AdminLogin />} />
          <Route path="receivers" element={<div className="text-white">Receivers Management (Coming Soon)</div>} />
          <Route path="files" element={<div className="text-white">Files Browser (Coming Soon)</div>} />
          <Route path="stats" element={<div className="text-white">Advanced Statistics (Coming Soon)</div>} />
          <Route path="settings" element={<div className="text-white">System Settings (Coming Soon)</div>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;